/**
 * @generated SignedSource<<a208a467e2246f5b8e8cdc7fee617480>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ServiceDocumentationPeriodScreenQuery$variables = {
  serviceDocumentationId: string;
};
export type ServiceDocumentationPeriodScreenQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"ServiceDocumentationPeriodScreen_serviceDocumentationQuery">;
  } | null;
};
export type ServiceDocumentationPeriodScreenQuery = {
  variables: ServiceDocumentationPeriodScreenQuery$variables;
  response: ServiceDocumentationPeriodScreenQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceDocumentationId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "serviceDocumentationId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ServiceDocumentationPeriodScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ServiceDocumentationPeriodScreen_serviceDocumentationQuery"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ServiceDocumentationPeriodScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceDocumentationId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "month",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "year",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LastUploadedFile",
                "kind": "LinkedField",
                "name": "lastUploadedFile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mimeType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pathInStorage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "ServiceDocumentation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c0e896c22318ddf50825832a588ed410",
    "id": null,
    "metadata": {},
    "name": "ServiceDocumentationPeriodScreenQuery",
    "operationKind": "query",
    "text": "query ServiceDocumentationPeriodScreenQuery(\n  $serviceDocumentationId: ID!\n) {\n  node(id: $serviceDocumentationId) {\n    __typename\n    ...ServiceDocumentationPeriodScreen_serviceDocumentationQuery\n    id\n  }\n}\n\nfragment ServiceDocumentationPeriodScreen_serviceDocumentationQuery on ServiceDocumentation {\n  serviceDocumentationId\n  month\n  year\n  lastUploadedFile {\n    mimeType\n    pathInStorage\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "eb9c1bd0dd62bf71c467250f8fc19b02";

export default node;
